export default __webpack_public_path__ + "_/images/app/manual/manual1-5a8adf5ef0bd2760708c27dcc699b84eb83c553fcdd5d541b735201ff1289125.png";